import { render, staticRenderFns } from "./DialogContentPremiumBreakdown.vue?vue&type=template&id=1722481a&scoped=true&"
import script from "./DialogContentPremiumBreakdown.vue?vue&type=script&lang=js&"
export * from "./DialogContentPremiumBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./DialogContentPremiumBreakdown.vue?vue&type=style&index=0&id=1722481a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722481a",
  null
  
)

export default component.exports